"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingBone = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Math_1 = require("../../utils/Math");
var SkeletonLoaderInfoContext_1 = require("./SkeletonLoaderInfoContext");
var SkeletonLoaderStyles_1 = require("./SkeletonLoaderStyles");
var PostShineDelayMs = 600;
/**
 * A placeholder element used to indicate content will show up, once an asynchronous task has completed.
 * All `<LoadingBone/>`s whose visibility is controlled by the same asynchronous request,
 * should be nested under the same parent <SkeletonLoaderWidget />.
 */
exports.LoadingBone = function (props) {
    var className = props.className, style = props.style, restProps = tslib_1.__rest(props, ["className", "style"]);
    /**
     * Offset in pixels from the left edge of the parentEl, where this component is.
     * This is used to make it look like the shine transitions across the entire page.
     */
    var _a = React.useState(0), xOffset = _a[0], setXOffset = _a[1];
    var elementRef = React.useRef(null);
    var _b = React.useState(80), shineWidth = _b[0], setShineWidth = _b[1];
    var _c = React.useContext(SkeletonLoaderInfoContext_1.SkeletonLoaderInfoContext), clientRect = _c.clientRect, darkMode = _c.darkMode, isInitialized = _c.isInitialized;
    /** We add an extra 600ms to the duration, before the animation starts again */
    var pixelsPerSecond = clientRect.width / ((SkeletonLoaderStyles_1.ShineAnimationDurationMs - PostShineDelayMs) / 1000);
    /**
     * At what point in the animation, does it complete, allowing for 600ms of additional rest time.
     * @default ```0.7```
     */
    var animationCompletePercentage = clientRect.width / (clientRect.width + (pixelsPerSecond * PostShineDelayMs / 1000)) || .7;
    React.useEffect(function () {
        var _a, _b;
        var selfLeft = ((_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left) || 0;
        setXOffset(selfLeft - clientRect.left);
        var newWidth = (((_b = elementRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width) || 0) * .20;
        setShineWidth(Math_1.clamp(newWidth, 80, 200));
    }, [clientRect.width, clientRect.left]);
    var SkeletonLoaderShineAnimation = React.useMemo(function () {
        var _a;
        return TypeStyle.keyframes((_a = {
                '0%': {
                    left: '0',
                    marginLeft: -shineWidth,
                }
            },
            _a[animationCompletePercentage * 100 + "%"] = {
                left: clientRect.width,
                marginLeft: 0,
            },
            _a['100%'] = {
                left: clientRect.width,
                marginLeft: 0,
            },
            _a));
    }, [animationCompletePercentage, clientRect.width]);
    var getDynamicStyle = function () { return ({
        backgroundColor: SkeletonLoaderStyles_1.getBackgroundColor(darkMode ? .4 : 1),
    }); };
    var getShineStyle = function () { return ({
        animationName: SkeletonLoaderShineAnimation,
        animationDelay: (xOffset / pixelsPerSecond) * 1000 + "ms",
        background: "linear-gradient(to right, transparent, " + SkeletonLoaderStyles_1.getShineColor(darkMode ? .6 : 1) + ", transparent)",
        marginLeft: -shineWidth,
        width: shineWidth,
    }); };
    return (React.createElement("div", tslib_1.__assign({ className: TypeStyle.classes(SkeletonLoaderStyles_1.LoadingBoneStyleName, className) }, restProps, { children: React.createElement("div", { className: SkeletonLoaderStyles_1.ShineStyleName, style: tslib_1.__assign({}, (isInitialized && getShineStyle())) }), ref: elementRef, style: tslib_1.__assign(tslib_1.__assign({}, style), getDynamicStyle()) })));
};
exports.LoadingBone.displayName = 'LoadingBone';
//# sourceMappingURL=LoadingBone.js.map